
export const ConstituentNav = 'drawer-constituent-nav'
export const ReportNav = "drawer-reports-nav"
export const BatchTemplate = "drawer-batch-template"